import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { showToast } from '../../../store/actions'
import { BASE_URL } from '../../../utils/response'
import InputCom from '../InputCom'
import LoaderStyleOne from '../Loaders/LoaderStyleOne'
import './AddressModal.css'

const validationSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  street: Yup.string().required('Street is required'),
  zipCode: Yup.string().required('Zip Code is required'),
  type: Yup.string().required('Type is required'),
  stateId: Yup.string().required('State is required'),
  cityId: Yup.string().required('City is required'),
})

function AddressModal({ isOpen, onClose, onSuccess, setSuccess }) {
  const shopUserData = useSelector((state) => state.shopUserData.shopUserData)
  const dispatch = useDispatch()

  const [cities, setCities] = useState([])
  const [states, setStates] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const stateId = watch('stateId')

  const modalClassName = isOpen ? 'modal-overlay open' : 'modal-overlay'

  const close = () => {
    onClose()
    reset()
  }

  const handleFormSubmit = async (data) => {
    setLoading(true)
    const bodyFormData = new FormData()
    bodyFormData.append('title', data.title)
    bodyFormData.append('street_address', data.street)
    bodyFormData.append('state_id', data.stateId)
    bodyFormData.append('city_id', data.cityId)
    bodyFormData.append('type', data.type)
    bodyFormData.append('postal_code', data.zipCode)

    try {
      const res = await axios.post(`${BASE_URL}/user/address`, bodyFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${shopUserData.token}`,
        },
      })

      if (res.status === 200) {
        dispatch(showToast('Address saved successfully!', 'success', 2000))
        onClose()
        reset()
        onSuccess(true)
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        setError(error.response.data.message)
      } else {
        setError('Network Error: Please try again later.')
      }
    } finally {
      setLoading(false)
    }
  }

  const fetchStates = async () => {
    try {
      const apiRes = await axios.get(`${BASE_URL}/states?country=United States`, {
        headers: {
          Authorization: `Bearer ${shopUserData.token}`,
        },
      })
      setStates(apiRes?.data?.data)
    } catch (error) {
      console.error('Error fetching states:', error)
    }
  }

  const fetchCities = async (stateName) => {
    try {
      const apiRes = await axios.get(`${BASE_URL}/cities?state=${stateName}&country=United States`, {
        headers: {
          Authorization: `Bearer ${shopUserData.token}`,
        },
      })
      setCities(apiRes?.data?.data)
    } catch (error) {
      console.error('Error fetching cities:', error)
    }
  }

  useEffect(() => {
    fetchStates()
  }, [])

  useEffect(() => {
    const selectedState = states.find((s) => s.id == stateId)
    if (selectedState?.name) {
      fetchCities(selectedState.name)
    }
  }, [stateId])

  return (
    <div className={`${modalClassName}`}>
      <div className="modal-content-signup relative">
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 z-20">
            <LoaderStyleOne />
          </div>
        )}
        <div className="lg:w-[572px] w-full bg-white flex flex-col justify-center sm:p-10 p-5 border border-[#E0E0E0]">
          <div className="w-full">
            <div className="title-area flex flex-col justify-center items-center relative text-center mb-4">
              <h1 className="text-[24px] font-bold leading-[54px] text-qblack">Save/Update Address</h1>
              {error && (
                                    <div style={{ color: 'red', marginBottom: 10, textAlign:'center' }}>{error}</div>
                                )}
              <button onClick={close} className="close-button">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path
                    d="M9.7 0.3C9.3 -0.1 8.7 -0.1 8.3 0.3L5 3.6L1.7 0.3C1.3 -0.1 0.7 -0.1 0.3 0.3C-0.1 0.7 -0.1 1.3 0.3 1.7L3.6 5L0.3 8.3C-0.1 8.7 -0.1 9.3 0.3 9.7C0.7 10.1 1.3 10.1 1.7 9.7L5 6.4L8.3 9.7C8.7 10.1 9.3 10.1 9.7 9.7C10.1 9.3 10.1 8.7 9.7 8.3L6.4 5L9.7 1.7C10.1 1.3 10.1 0.7 9.7 0.3Z"
                    fill="#AAAAAA"
                  />
                </svg>
              </button>
            </div>

            <form onSubmit={handleSubmit(handleFormSubmit)} noValidate>
              <div className="input-area">
                <div className="input-item mb-3">
                  <InputCom
                    label="Title"
                    placeholder="Home, Office A..."
                    inputClasses="h-[40px]"
                    {...register('title')}
                  />
                  <p className="text-red-500 text-xs mt-1">{errors.title?.message}</p>
                </div>

                <div className="input-item mb-3">
                  <InputCom
                    label="Street"
                    placeholder="3rd Street..."
                    inputClasses="h-[40px]"
                    {...register('street')}
                  />
                  <p className="text-red-500 text-xs mt-1">{errors.street?.message}</p>
                </div>

                <div className="input-item mb-3">
                  <label className="text-sm text-gray-500 mb-2 block">State</label>
                  <select
                    {...register('stateId')}
                    className="input-field border-color text-sm px-6 w-full bg-white pt-[10px] pb-[10px]"
                  >
                    <option value="">Select an option</option>
                    {states.map((s) => (
                      <option key={s.id} value={s.id}>{s.name}</option>
                    ))}
                  </select>
                  <p className="text-red-500 text-xs mt-1">{errors.stateId?.message}</p>
                </div>

                <div className="input-item mb-3">
                  <label className="text-sm text-gray-500 mb-2 block">City</label>
                  <select
                    {...register('cityId')}
                    className="input-field border-color text-sm px-6 w-full bg-white pt-[10px] pb-[10px]"
                  >
                    <option value="">Select an option</option>
                    {cities.map((c) => (
                      <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                  </select>
                  <p className="text-red-500 text-xs mt-1">{errors.cityId?.message}</p>
                </div>

                <div className="input-item mb-3">
                  <InputCom
                    label="Zip Code"
                    placeholder="Postal Code..."
                    type="number"
                    inputClasses="h-[40px]"
                    {...register('zipCode')}
                  />
                  <p className="text-red-500 text-xs mt-1">{errors.zipCode?.message}</p>
                </div>

                <div className="input-item mb-3">
                  <label className="text-sm text-gray-500 mb-2 block">Type</label>
                  <select
                    {...register('type')}
                    className="input-field border-color text-sm px-6 w-full bg-white pt-[10px] pb-[10px]"
                  >
                    <option value="">Select an option</option>
                    <option value="General">General</option>
                    <option value="Shipping">Shipping</option>
                    <option value="Billing">Billing</option>
                  </select>
                  <p className="text-red-500 text-xs mt-1">{errors.type?.message}</p>
                </div>
              </div>

              <div className="signin-area mb-3.5">
                <div className="flex justify-center">
                  <button
                    type="submit"
                    className="black-btn mb-6 text-sm text-white w-full h-[50px] font-semibold flex justify-center bg-purple items-center"
                  >
                    <span>Save</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddressModal
